
<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from "svelte";
    import Fa from 'svelte-fa'
    import { faLineChart } from '@fortawesome/free-solid-svg-icons'
    import CheeseSellOff from '../components/CheeseSellOff.svelte'

    let modal;

    export let customer = '';
    
    const dispatch = createEventDispatcher();
    
    onMount(async function () {});

    function clickExecuted() {
        modal.show();
    }

    function accepted() {
        dispatch('sellOffConfirmed', {
            
        });
    }
</script>

<div class="IconSellOff" on:click={clickExecuted}>
    <Fa icon={faLineChart} on:clicked={clickExecuted}/>
</div>
<div class="TextSellOff" on:click={clickExecuted}>Ausbuchen&nbsp;&nbsp;&nbsp;</div>

<CheeseSellOff bind:this={modal} customer={customer} on:accepted={accepted}/>

<style>
    .IconSellOff {
        padding-right: 10px;
        cursor: pointer;
        color: orange;
    }
    
    .TextSellOff {
        cursor: pointer;
    }
</style>